<template>
  <div>
    <h1>Gestion des campagnes fournisseur</h1>
    <div>
      <label>Campagne : </label>
      <select v-model="selectedYear">
        <option v-for="year of yearList" :value="year" :key="year">{{year}}</option>
      </select>
    </div>
    <br />
    <vue-good-table v-if="selectedYear !== -1" :columns="columns"
                    :rows="frsList"
                    :sort-options="{enabled: true}"
                    :pagination-options="{
                                        enabled: true,
                                        rowsPerPageLabel: 'Lignes par page',
                                        ofLabel: 'sur',
                                        nextLabel: 'Suivant',
                                        prevLabel: 'Précédent',
                                        allLabel: 'Toutes'
                                    }">
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'OnCampaign'">
          <input type="checkbox" @click="toggleCampaign($event, props)"
                 :checked="props.row[props.column.field]" />
        </span>
        <span v-else>
          {{props.formattedRow[props.column.field]}}
        </span>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
  import { getFrsListAdminAll, getFrsOnCampaignGuidList, toggleFrsCampaign } from "@/utils/frs";
  import { getCampaignsYear } from "@/utils/period";

  export default {
    name: "FrsCampaign",
    data() {
      return {
        frsListAll: [],
        frsGuidCampaignList: [],
        yearList: [],
        selectedYear: -1,
      }
    },
    mounted() {
      getCampaignsYear().then(years => {
        if (!years) return;
        this.yearList = years;
        // On sélectionne par défaut la dernière année
        this.selectedYear = Math.max(...this.yearList);
      });
    },
    watch: {
      // Lorsque la campagne change (ou s'initialise), on récupère toutes les infos sur les fournisseurs selon cette campagne
      selectedYear() {
        if (this.selectedYear !== -1) {
          getFrsListAdminAll(this.selectedYear).then(res => this.frsListAll = res)
          this.getFrsOnCampaign();
        }
      }
    },
    methods: {
      getFrsOnCampaign() {
        // On récupère la liste des Guids des frs sur la campagne sélectionnée
        if (this.selectedYear !== -1) {
          getFrsOnCampaignGuidList(this.selectedYear).then(res => this.frsGuidCampaignList = res);
        }
      },
      toggleCampaign(e, ctx) {
        // On empêche la case de se cocher/décocher automatiquement => màj depuis données pour que ça soit synchronisé
        e.preventDefault();
        // On met à jour la liste des fournisseurs sur la campagne sélectionnée
        toggleFrsCampaign(ctx.row.Guid, this.selectedYear).then(() => this.getFrsOnCampaign());
      }
    },
    computed: {
      frsList() {
        // Récupère la liste des fournisseurs avec une info en plus : s'il est ou non sur la campagne
        return this.frsListAll.map(frs => {
          const isOnCampaign = this.frsGuidCampaignList.indexOf(frs.Guid) !== -1;
          frs.OnCampaign = isOnCampaign;
          return frs;
        })
      },
      columns() {
        // Status sans doublons pour choix du filtre
        const uniqStatus = this.frsList.filter((f, i) => this.frsList.findIndex(_f => _f.Status == f.Status) == i).map(f => f.Status);

        return [
          { label: "Code Intranet", field: "CodeIntranet", filterOptions: { enabled: true, } },
          { label: "Code Compta", field: "IdCompta", filterOptions: { enabled: true, } },
          { label: "Nom", field: "Name", filterOptions: { enabled: true } },
          { label: "Status", field: "Status", filterOptions: { enabled: true, placeholder: "Tous", filterDropdownItems: uniqStatus } },
          { label: "Pays", field: "CountryGathering", filterOptions: { enabled: true } },
          { label: "Famille", field: "N1", filterOptions: { enabled: true } },
          { label: "Sous famille", field: "N2", filterOptions: { enabled: true } },
          {
            label: "Sur la campagne ?",
            field: "OnCampaign",
            filterOptions: {
              enabled: true,
              placeholder: "Tous",
              filterDropdownItems: ["Oui", "Non"],
              filterFn: (data, filterString) => {
                return filterString == "Oui" ? data : !data;
              }
            }
          }
        ]
      }
    }
  }
</script>

<style scoped>
  table * {
    font-size: 12px !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Achat/FrsCampaign.vue